import { LabelStyles } from '@tableau/catalog-ui-temp';
import DesignTokens from '@tableau/design-tokens';
import { ButtonWidget, TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';
import { showCreateGroupSetDialog } from '~src/userManagement/groupsets/services/actions/CreateGroupSetDialogAction';

import { Messages } from '../../../../codegen/Localize';


namespace Styles {

  export const Count = cssClass('space-header', 'count', {
    color: applyColor(DesignTokens.color.font.default.secondary, CommonStyles.Colors.AccessibleSecondaryTextColor),
    fontSize: '14px'
  });
}

export interface AllGroupSetsSpaceOwnProps {
  readonly siteName: string;
}

export interface AllGroupSetsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedGroupSets: number;
  readonly canSessionUserManageUsers: boolean;
}

export interface AllGroupSetsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllGroupSetsSpaceProps = AllGroupSetsSpaceOwnProps & AllGroupSetsSpaceStateProps & AllGroupSetsSpaceDispatchProps;

export class AllGroupSetsSpace extends React.PureComponent<AllGroupSetsSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.groupSets() });
    this.props.requestSpaceContents();
  }

  public componentDidUpdate(prevProps: AllGroupSetsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={SpaceContainerStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>
              {Messages.groupSets()}
            </div>
            { <div className={Styles.Count} data-tb-test-id={ '-header-count'}>
              {!this.props.isBusyFetchingItems ? L10n.localizedCount(this.props.numberOfFetchedGroupSets) : ''}
            </div>}
          </div>
          <div style={LabelStyles.SpaceHeader}>
            {Messages.groupSetsSpaceDesciption()}
            <TextLinkWidget testId={'group-set-learn-more'}
                          target={'_blank'}
                          className={learnMoreStyle}
                          href={HelpService.getHelpUrlByCategory('group-set')}>
              {Messages.learnMore()}
            </TextLinkWidget>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.addGroupSetButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.groupSetsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  };

  handleClick: React.MouseEventHandler = e => {
    showCreateGroupSetDialog();
  };

  private addGroupSetButton = () => {
    return (
      <ButtonWidget onClick={this.handleClick} testId='primary'>{Messages.addGroupSet()}</ButtonWidget>
    );
  };
}
